// lightTheme/darkTheme 둘 다 값이 var(--c6-color-*) 참조라 객체 자체는 동일 — 실제 light/dark
// 분기는 GlobalStyle이 :root[data-c6-theme="..."]에 emit하는 CSS 변수 값에서 일어난다.
// 별도 export로 두는 이유: ThemeProvider의 mode prop과 대칭 + 향후 dark-only theme override가
// 생길 때 import site를 안 바꾸도록.
import { lightTheme } from "./lightTheme";

export const darkTheme = lightTheme;
